/**
 * Retrieves data from a script tag with a specific data-id attribute.
 * This function is useful for extracting JSON data embedded in script tags.
 * @param dataTd
 */
export const getDataFromScriptTag = <T>(dataTd: string): T | undefined => {
    if (
        typeof window === "undefined" ||
        typeof document === "undefined" ||
        typeof document.head === "undefined"
    ) {
        return;
    }
    const scriptTag = document.querySelector(
        `script[type="application/json"][data-id="${dataTd}"]`
    );
    if (!scriptTag) {
        console.warn(
            `No script tag found with data-id="${dataTd}". Please check your markup.`
        );
        return;
    }
    try {
        return JSON.parse(scriptTag.innerHTML) as T;
    } catch (error) {
        console.error("Failed to parse JSON from script tag", error);
    }
    return undefined;
};
